import { FormEvent, useEffect, useState } from 'react';

import { IconAlertHexagon } from '@tabler/icons-react';

import { Anchor, Button, Checkbox, Group, Loader, Modal, Stack, Text, Title } from '@optiro/ui';

import { useUpdateAccount } from '@/hooks/useUpdateAccount';
import { Account } from '@/types/types';

const TermsAndConditions = ({ open, accountId }: { open: boolean; accountId: Account['id'] }) => {
  const { mutate, isPending, isSuccess } = useUpdateAccount(accountId);
  const [controlledOpen, setOpen] = useState(open);
  const [account, setAccount] = useState<Partial<Account>>({
    terms_and_conditions_accepted: false,
    marketing_opt_in: false,
  });

  const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setAccount((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { file: _file, ...rest } = account;
    mutate(rest);
  };

  useEffect(() => {
    if (isSuccess) {
      setOpen(false);
    }
  }, [isSuccess]);

  return (
    <Modal
      opened={controlledOpen}
      onClose={() => setOpen(false)}
      title={
        <Group gap="sm">
          <IconAlertHexagon size={20} stroke={1.5} />
          <Title order={4}>Du mangler at godkende vilkår</Title>
        </Group>
      }
      closeOnClickOutside={false}
      closeOnEscape={false}
      withCloseButton={false}
      centered
      overlayProps={{ blur: 5 }}
    >
      <form onSubmit={handleSubmit}>
        <Stack gap="md">
          {isPending ? (
            <Loader mx="auto" />
          ) : (
            <>
              <Checkbox
                name="terms_and_conditions_accepted"
                checked={account.terms_and_conditions_accepted}
                onChange={handleCheckBox}
                required
                label={
                  <Text size="sm">
                    Jeg accepterer Optiros{' '}
                    <Anchor
                      href={`${import.meta.env.VITE_LANDING_PAGE_URL}/terms-and-conditions`}
                      target="_blank"
                      c={'blue.6'}
                      underline="hover"
                    >
                      Vilkår, betingelser
                    </Anchor>{' '}
                    og{' '}
                    <Anchor
                      href={`${import.meta.env.VITE_LANDING_PAGE_URL}/privacy-policy`}
                      target="_blank"
                      c={'blue.6'}
                      underline="hover"
                    >
                      privatlivspolitik
                    </Anchor>
                  </Text>
                }
              />
              <Checkbox
                name="marketing_opt_in"
                checked={account.marketing_opt_in}
                onChange={handleCheckBox}
                label="Ja tak, jeg vil gerne modtage nyheder og tilbud fra Optiro på e-mail."
              />
            </>
          )}
          <Group align="right">
            <Button type="submit">Indsend</Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
};

export { TermsAndConditions };
